module.exports = __webpack_public_path__ + "img/15.96aa07c6.svg";